import './Footer.css';

function Footer() {
    return (
        <>
            <div className="links-container" id='footer'>
                <div className="links-wrap">
                    <p className='links-head'><span>Quick Links</span></p>
                    <div className="link-row">
                        <div className="link-box box1">
                            <img src="images/Home/Acc_GT_Dimensional_RGB.png" alt="AccentureIcon" className='accenture-icon' />
                            <p className='follow-site'>Follow our site</p>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://mylearning.accenture.com/mylearningui/learner/home" target="_blank">myLearning <img src="images/Home/popup-latest.png" alt="" className='links-icon' /></a>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://connectedlearning.accenture.com/learningactivities" target="_blank">Learning Boards <img src="images/Home/popup-latest.png" alt="" className='links-icon' /></a>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://.lkm.accenture.com/LKM-eCatalog/home" target="_blank">LKM eCatalogs <img src="images/Home/popup-latest.png" alt="" className='links-icon' /></a>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://atci.lkm.accenture.com/learning-calendar/" target="_blank">LKM Calendar <img src="images/Home/popup-latest.png" alt="" className='links-icon' /></a>
                        </div>
                    </div>
                    {/* <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://deepknowledge.accenture.com/" target="_blank">Deep Knowledge <img src="images/Home/popup-latest.png" alt="PopupIcon" className='links-icon' /></a>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="footer_container">
                <p>
                    &copy; 2023 Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by Learning Integrated Services - LKM, ATC.                    
                </p>
            </div>
        </>
    )
}

export default Footer;
